import { render, staticRenderFns } from "./shipsmain.vue?vue&type=template&id=8e5d1be0&scoped=true"
import script from "./shipsmain.vue?vue&type=script&lang=js"
export * from "./shipsmain.vue?vue&type=script&lang=js"
import style0 from "./shipsmain.vue?vue&type=style&index=0&id=8e5d1be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5d1be0",
  null
  
)

export default component.exports